export class ISTabLayout {
    constructor(
        public selectedMenu: number,
        public tabItems: ISTabItem[],
        public verticalLayout: boolean = false,
        public isSigaApp?: boolean,
    ) { }
}

export class ISTabItem {
    constructor(
        public id: any,
        public label: string,
        public icon?: string,
        public iconClass?: string,
        public iconStyle?: string,
        public hideTab?: boolean,
        public badge?: number
    ) { }
}